var Primary = require('Decorators').Primary;

var GalleryKey = function () {
    this.GalleryKey          = Primary(String);
    this.Name                = String;
    this.IsCurrentGallery    = Number;
    this.ClientToken         = String;
    this.ContentManagerToken = String;
    this.LastLoadedOn        = Date;

}

module.exports = GalleryKey;